/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component002.less';

interface IComponent002ListItem {
  text: string;
  img: string;
}

interface IComponent002Item {
  title: string;
  color: string;
  listItems: IComponent002ListItem[];
}

interface IComponent002Props {
  items: IComponent002Item[];
  className?: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  items,
  className,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <div className={`component component002 ${className}`}>
      {items.map((item: IComponent002Item, index: number) => (
        <div key={index} className="component002-section">
          <div
            className="component002-title"
            style={{ backgroundColor: item.color }}
            dangerouslySetInnerHTML={{
              __html: item.title,
            }}
          />
          <div className="component002-body">
            <div className="component002-content">
              {item.listItems.map((itm: IComponent002ListItem, idx: number) => (
                <div key={idx} className="component002-content-body">
                  <img
                    className="component002-content-body-img"
                    src={getImg(itm.img)}
                    alt=""
                  />
                  <div
                    className="component002-content-body-text"
                    dangerouslySetInnerHTML={{
                      __html: itm.text,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default Component002;
